import { Dispatch } from "react";
import { connect } from "react-redux";
import * as actions from "../common/actions";
import CustomizedSearch from "../components/PeerGroup/CustomizedSearch";
import { All, KeyValue, Query, SortDirection } from "../interfaces";

function mapStateToProps({ appState }: All) {
  return {
    appState: appState.peerGroup,
    currentApp: appState.app,
    userId: appState.uuid,
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateSort: (sortField: string, sortDirection: SortDirection) => {
      dispatch(actions.updateSortOrder(sortField, sortDirection));
      dispatch(actions.searchPush());
    },
    updateUi: (
      uiField: string,
      uiValue: KeyValue[] | string[] | boolean | string | undefined | KeyValue,
    ) => {
      dispatch(actions.updateUi(uiField, uiValue));
      dispatch(actions.searchPush());
    },
    resetState: (appState: Query) => {
      dispatch(actions.resetState(appState));
      dispatch(actions.searchPush());
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CustomizedSearch);
